<template>

  <div>

    <el-form :inline="true" :model="query" @keyup.enter.native="load">

      <el-form-item label="凭证号">

        <el-input v-model="query.voucherCode" size="small" clearable />

      </el-form-item>

      <el-form-item label="记账">

        <el-select v-model="query.approveStatus" clearable size="small" style="width:100px">

          <el-option label="未记账" value="0" />

          <el-option label="已记账" value="2" />

        </el-select>

      </el-form-item>

      <el-form-item>

        <el-button v-if="isAuth('finance:voucher:list')" type="primary" size="small" @click="load">查询</el-button>

      </el-form-item>

      <el-form-item>

        <el-button v-if="isAuth('finance:voucher:save')" type="primary" size="small" @click="addOrUpdateHandle()">新增</el-button>

      </el-form-item>

    </el-form>



    <el-table :data="shown" border v-loading="loading" :header-cell-style="headStyle">

      <el-table-column type="index" label="序号" width="60" align="center" />

      <el-table-column prop="voucherCode" label="凭证号" width="140">

        <template slot-scope="scope">

          <a v-if="isAuth('finance:voucher:info')" class="code-link" @click="addOrUpdateHandle(scope.row.voucherId, true)">{{ scope.row.voucherCode }}</a>

          <span v-else>{{ scope.row.voucherCode }}</span>

        </template>

      </el-table-column>

      <el-table-column prop="voucherDate" label="凭证日期" width="120" align="center" />

      <el-table-column prop="totalDebit" label="借方合计" width="120" align="right">

        <template slot-scope="scope">{{ money(scope.row.totalDebit) }}</template>

      </el-table-column>

      <el-table-column prop="totalCredit" label="贷方合计" width="120" align="right">

        <template slot-scope="scope">{{ money(scope.row.totalCredit) }}</template>

      </el-table-column>

      <el-table-column prop="approveStatus" label="状态" width="90" align="center">

        <template slot-scope="scope">

          <el-tag v-if="scope.row.approveStatus === '2'" type="success" size="small">已记账</el-tag>

          <el-tag v-else type="info" size="small">未记账</el-tag>

        </template>

      </el-table-column>

      <el-table-column label="操作" width="140" align="center">

        <template slot-scope="scope">

          <el-button v-if="isAuth('finance:voucher:approve') && scope.row.approveStatus !== '2'" type="text" size="small" @click="approve(scope.row, true)">记账</el-button>

          <el-button v-if="isAuth('finance:voucher:unapprove') && scope.row.approveStatus === '2' && !Number(scope.row.managedVoucher)" type="text" size="small" @click="approve(scope.row, false)">弃审</el-button>

        </template>

      </el-table-column>

    </el-table>



    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="load" />

  </div>

</template>



<script>

import AddOrUpdate from './voucher-add-or-update'

import request from '../../api/request'

import auth from './financeAuth'



export default {

  name: 'Voucher',

  mixins: [auth],

  components: { AddOrUpdate },

  data() {

    return {

      query: { voucherCode: '', approveStatus: '' },

      list: [],

      addOrUpdateVisible: false

    }

  },

  computed: {

    shown() {

      return this.list.filter(row => {

        if (this.query.voucherCode && String(row.voucherCode || '').indexOf(this.query.voucherCode) < 0) return false

        if (this.query.approveStatus && String(row.approveStatus) !== this.query.approveStatus) return false

        return true

      })

    }

  },

  created() { this.load() },

  methods: {

    load() {

      this.loading = true

      request.get('/finance/voucher/list').then(res => { this.list = res.data || [] }).finally(() => { this.loading = false })

    },

    addOrUpdateHandle(id, readonly) {

      this.addOrUpdateVisible = true

      this.$nextTick(() => {

        this.$refs.addOrUpdate && this.$refs.addOrUpdate.init(id, readonly)

      })

    },

    approve(row, pass) {

      const url = pass ? '/finance/voucher/approve' : '/finance/voucher/unapprove'

      this.$confirm(pass ? '确定记账?' : '确定弃审?', '提示', { type: 'warning' }).then(() => {

        request.post(url, { id: row.voucherId }).then(() => {

          this.$message.success(pass ? '记账成功' : '弃审成功')

          this.load()

        }).catch(() => {})

      }).catch(() => {})

    }

  }

}

</script>



<style scoped>

.code-link { color: #348adb; cursor: pointer; }

</style>

